import React, { FC } from "react";
import { Box, Typography } from "@mui/material";

export const SnapshotBanner: FC = () => (
    <Box
        sx={{
            backgroundColor: "var(--tint)",
            border: "1px solid var(--border)",
            borderRadius: "12px",
            padding: "12px 16px",
            mb: 2
        }}
    >
        <Typography
            sx={{
                fontFamily: "CircularStd",
                fontSize: "14px",
                fontWeight: 500,
                color: "var(--accent-text)",
                lineHeight: 1.45
            }}
        >
            Changes apply to projects saved or updated after this point. Existing project quotes are not retroactively
            re-priced.
        </Typography>
    </Box>
);
